module.exports = __webpack_public_path__ + "img/camper_interiour_1.fd8a1b27.jpg";